/**
 * "Which line is this?" — the order / line / part panel at the top of a PO line
 * dialog.
 *
 * One component because it was two identical blocks: Propose Change and Update
 * Dates each carried their own copy, field for field, differing only in the
 * colour of the box around them. Extracted at gate round 1, where the honest
 * reason is that ProposeChangeModal had crossed helix-code's 500-line cap
 * (comments-C3) and this is the part of it that was never specific to proposing
 * anything.
 *
 * The tone stays the caller's: Propose Change is orange, like the action it
 * belongs to, and Update Dates is neutral.
 */

interface LineIdentityPanelProps {
  lineNumber: string | number;
  partNumber?: string;
  orderNumber?: string;
  /** The box's own classes — the caller owns the tone. */
  className?: string;
}

export function LineIdentityPanel({
  lineNumber,
  partNumber,
  orderNumber,
  className = 'bg-muted/40 border border-border',
}: LineIdentityPanelProps) {
  return (
    <div className={`rounded-lg p-3 space-y-2 ${className}`}>
      {orderNumber && (
        <div className="flex justify-between text-sm">
          <span className="font-medium">Order Number:</span>
          <span>{orderNumber}</span>
        </div>
      )}
      <div className="flex justify-between text-sm">
        <span className="font-medium">Line:</span>
        <span>{lineNumber}</span>
      </div>
      {partNumber && (
        <div className="flex justify-between text-sm">
          <span className="font-medium">Part:</span>
          <span className="font-mono">{partNumber}</span>
        </div>
      )}
    </div>
  );
}
